/**
 * TIER 2, reached from a gate. This is the one most people will see.
 *
 * T1 lets a participant HOLD value; T2 lets them MOVE it. So the gate that sends people here is the
 * Send button, and it is the most-hit gate in the product. It has to finish the job in one sitting.
 */

import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Link } from 'react-router-dom';
import { Tier2Form, UnderReview } from '@/components/kyc-forms';
import { useSession } from '@/lib/session-context';

export default function VerifyTier2() {
  const navigate = useNavigate();
  const { me, tier, refresh } = useSession();
  const [held, setHeld] = useState(false);

  if (!me) return null;
  if (held) return <UnderReview />;

  // T2 is built ON TOP of T1: the backend needs a verified identity before it will accept a proof of
  // address against it. Sending somebody straight to this form would have them fill in six fields and
  // then be refused, which is the worst possible order to discover a prerequisite in.
  if (tier === 'T0') {
    return (
      <div className="mx-auto max-w-md rounded-card border border-border bg-surface p-6 text-center">
        <h1 className="font-semibold text-ink">One step at a time</h1>
        <p className="mx-auto mt-2 max-w-sm text-sm text-ink-muted">
          We need to verify who you are before we can accept a proof of address against it.
        </p>
        <Link
          to="/verify/tier1"
          className="mt-5 inline-flex rounded-lg bg-primary px-4 py-2 text-sm font-medium text-white transition hover:bg-primary-light"
        >
          Verify my identity first
        </Link>
      </div>
    );
  }

  return (
    <div className="mx-auto max-w-md space-y-5">
      <header>
        <h1 className="text-page-title text-ink">Where your money comes from</h1>
        <p className="mt-1 text-sm text-ink-muted">
          You can already hold value. To <strong className="text-ink">send</strong> it, we need your
          address and a declaration of where your funds come from.
        </p>
      </header>

      <div className="rounded-card border border-border bg-surface p-5">
        <Tier2Form
          participantId={me.participant_id}
          onDone={async (outcome) => {
            if (outcome === 'under_review') {
              setHeld(true);
              return;
            }
            await refresh();
            navigate('/home');
          }}
        />
      </div>
    </div>
  );
}
